module.exports = __webpack_public_path__ + "assets/b0c601c0b124b6e742f9c0bbd30794cf.mp4";